export default __webpack_public_path__ + "media/color/act-16b8d3a2.svg";